var TECL_Navigation = {
    Initialise: function() {
        $('#bs-example-navbar-collapse-1').on('shown.bs.collapse', function() {
            $('#mobile-search-input').delay(300).focus();
        });
    }
};